module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "noStatic linkUsers",
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0px !important",
      "margin-right": "12px !important"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("User Type:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.linkType,
      "item-value": "id",
      "label": "User Type",
      "solo": ""
    },
    on: {
      "input": _vm.fncFetchUsers
    },
    model: {
      value: (_vm.linkTypeSingle),
      callback: function($$v) {
        _vm.linkTypeSingle = $$v
      },
      expression: "linkTypeSingle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "0px !important"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.userLinks != '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "0px !important"
    },
    attrs: {
      "lg12": ""
    }
  }, [(_vm.userLinks != '') ? _c('v-data-table', {
    staticClass: "elevation-1 linkTableMediumSmall",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.userLinks,
      "rows-per-page-items": [20, 40, 60, 80, 100],
      "search": _vm.search,
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          on: {
            "click": function($event) {
              return _vm.fncSaveLink(props.item.id, props.item.linked, props.item.companyName, props.item.fullname, props.item.type)
            }
          },
          model: {
            value: (props.item.linked),
            callback: function($$v) {
              _vm.$set(props.item, "linked", $$v)
            },
            expression: "props.item.linked"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_vm._v(_vm._s(props.item.fullname))])]
      }
    }], null, false, 705660100)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('center', [(_vm.userLinks == '' && _vm.linkTypeSingle != '' && _vm.loaded == false) ? _c('img', {
    staticClass: "imgLoader",
    staticStyle: {
      "padding-top": "0% !important"
    },
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()])], 1), _vm._v(" "), (_vm.userLinks == '' && _vm.linkTypeSingle != '' && _vm.loaded == true) ? _c('p', [_vm._v("No users / companies could be found to link / unlink")]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-4 pr-4 pt-4 pb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "pl-4 pr-1 pb-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}